import jobRepository from "../../repository/WorkflowJobRepository";
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {Job} from "@/model/Job";


const getData = async (jobId: string) => {
    try {
        const {data} = await jobRepository.read(jobId)
        return data.result as Job
    } catch (e) {
        throw e;
    }
}


const useJob = (jobId: string, enabled = true) => {
    return useQuery<Job, AxiosError>({
        queryKey: ["workflow", "job", jobId],
        queryFn: async () => getData(jobId),
        enabled,
        refetchInterval: (data) => (enabled && data?.status === "running" ? 3000 : false),
        refetchOnWindowFocus: false,
        useErrorBoundary: false,
    })
}

export default useJob;
